module.exports = __webpack_public_path__ + "media/country_flags/mr-dd845897.png";